import React from 'react';
import { Suspense, lazy } from 'react';

import GoLocation from '@meronex/icons/go/GoLocation';
import Home from '../modules/home/Home';

const iconSize = 20;

export const views = {
  singlePage:   {
        id: 'home',
        label: 'Home',
        icon: <GoLocation size={iconSize} />,
        component: <Home />,
      },
  // multiPage: [
  //   {
  //     id: 'home',
  //     label: 'Home',
  //     icon: <GoLocation size={iconSize} />,
  //     component: <Home />,
  //   },
  // ],
  showFooter: false,
};
